import { useMemo } from 'react';

import qs from 'qs';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/article/pageContext';
import { generateAiSapParam } from '#src/app/shared/utils/generateAiSapParam';

type Result = ModelHookResult<
	{
		heading: string;
		subheading: string | null;
		heroImage: {
			title?: string;
			url?: string;
		} | null;
		sapAiUrl: string;
	},
	{
		trackSapClick: () => void;
		trackSapAiClick: () => void;
	}
>;

export function usePageHeading(): Result {
	const {
		data: {
			article: { heading, subheading, heroImage },
			aiSapId,
		},
	} = usePetitionGuidesPageData();

	const track = useTracking();

	return {
		data: {
			heading,
			subheading,
			heroImage,
			sapAiUrl: useMemo(
				() =>
					`/start-a-petition/intro?${qs.stringify({ state: generateAiSapParam(aiSapId), source_location: 'petition_guides_article' })}`,
				[aiSapId],
			),
		},
		actions: {
			trackSapClick: () => {
				void track('petition_guides_article_sap_click_banner');
			},
			trackSapAiClick: () => {
				void track('petition_guides_article_sap_ai_click_banner');
			},
		},
	};
}
